import { AddAccountResultModel, GetAddAccountParamater, addADIAccount } from "@NA/Services/ADIAddAccountService";

import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    HasOnError,
    HasOnSuccess,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<GetAddAccountParamater & HasOnSuccess & HasOnError, AddAccountResultModel>;

export const DispatchADIAddAccount: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/GetADIAddAccount",
        result: props.parameter,
    });
};

export const LoadADIAddAccount: HandlerType = async (props: any) => {
    props.apiResult = await addADIAccount(props.parameter);
};

export const DispatchCompleteLoadADIAddAccount: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult as any);
        props.dispatch({
            type: "Custom/DispatchCompleteLoadADIAddAccount",
            bannerCarousel: props.apiResult,
        });
    } else {
        props.parameter.onError?.(props.apiResult);
    }
};

export const chain = [DispatchADIAddAccount, LoadADIAddAccount, DispatchCompleteLoadADIAddAccount];

const adiAddAccount = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        email: "",
        firstName: "",
        lastName: "",
        properties: {
            isBecomeACustomerPage: false,
            phone: "",
            captchaResponse: "",
        },
    },
    "adiAddAccount",
);
export default adiAddAccount;
